import(/* webpackMode: "eager", webpackExports: ["PageTemplate"] */ "/vercel/path0/src/components/PageTemplate.tsx");
